import React from "react";
import "./Slogan.css";

const Slogan = () => {
  return <div className="slogan">eat pnppls * wear pnppls * vibe pnppls</div>;
};

export default Slogan;
